import React, { useState, useEffect, useCallback } from "react";
import ReactDOM from 'react-dom';
import { useParams, useNavigate } from "react-router-dom";
import CustomerNavbar from "./CustomerNavbar";
import axios8000 from "../services/8000AxiosInstance";
import axios8001 from "../services/axios8001";
import axios8200 from "../services/axios8200";
import axios8400 from "../services/axios8400";
import "./Customer.css";
import askCoachIcon from "../assets/icons/ask-coach-icon.png";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";


const CustomerPage = () => {
  const { customer_name } = useParams();
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null); // "askCoach" or "editTask"

  const [customer, setCustomer] = useState({
    customer_id: "",
    customer_name: "",
    contact: [],
    industry: "",
  });
  const [contactInput, setContactInput] = useState("");
  const [industryInput, setIndustryInput] = useState("");
  const [opportunities, setOpportunities] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [accountMetrics, setAccountMetrics] = useState({
    tasks_per_quarter: {},
    learnings: "N/A",
    tasks_delayed_per_role: {},
  });
  
  // Snackbar States
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isGeneratingTasks, setIsGeneratingTasks] = useState(false);
  const [isRefreshingTasks, setIsRefreshingTasks] = useState(false);
  const [isSavingTasks, setIsSavingTasks] = useState(false);
  const [isSavingAndClosing, setIsSavingAndClosing] = useState(false);
  const decodedCustomerName = decodeURIComponent(customer_name);



  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open state
  const [modalVisible, setModalVisible] = useState(false); // Modal visibility state
  const [activeTask, setActiveTask] = useState(null); // Active task being edited
  const closeModal = (modalType) => {
    setModalVisible(false);
    setActiveModal(null); // Reset active modal
  
    if (modalType === "coach") {
      setIsCoachModalOpen(false);
    }
  
    if (modalType === "task") {
      setActiveTask(null);
    }
  
    if (modalType === "saveOpportunity") {
      setFormData({
        customerName: "",
        opportunityName: "",
        leadDetails: "",
        persona: "",
      });
    }
  };
  
  const closeCoachModal = () => {
    setIsCoachModalOpen(false);
    setActiveModal(null); // Reset active modal
  };
    
  
  const [newUpdate, setNewUpdate] = useState(""); // State for new execution update

  const openEditModal = () => {
    setContactInput(customer.contact.join(", ")); // Populate with current contacts
    setIndustryInput(customer.industry); // Populate with current industry
    setIsModalOpen(true); // Open modal
  };
  
 // States for AskValueCreationStrategyCoach
 const [chatInput, setChatInput] = useState("");
 const [conversationHistory, setConversationHistory] = useState([]);
 const [tasks, setTasks] = useState([]);
 const [isCoachModalOpen, setIsCoachModalOpen] = useState(false);
 const [accounts, setAccounts] = useState({
  customer_overview: "",
  relationship_building_plan: "",
  value_creation_plan: "",
});


 // States for chat tile
 const [chatMessages, setChatMessages] = useState([]);
 const [loadingChat, setLoadingChat] = useState(false);
 const [inputValue, setInputValue] = useState("");
 const [showAskCoachTile, setShowAskCoachTile] = useState(false);
 

 const contexts = {
  "Lead Next Steps": "Provide personalized next steps for nurturing the lead and progressing the opportunity based on its current stage, MEDDICC alignment, and customer priorities.",
  "Fetch MEDDICC": "Retrieve and validate key MEDDICC components for this opportunity. Highlight missing elements, suggest actions, and provide questions to strengthen alignment.",
  "Competitor Insights": "Analyze potential competitors in this opportunity and suggest strategies to differentiate our solution, including objections to raise against competitors.",
  "Risk Mitigation": "Identify potential risks in this opportunity, such as low engagement or weak champions, and recommend actions to mitigate these risks.",
  "Analyze Tasks": "Assess pending tasks for the opportunity to ensure alignment with sales strategy. Highlight overdue or critical tasks and suggest adjustments for improved progress.",
  "Persona Analysis": "Analyze the personas involved in this opportunity. Highlight their priorities, influence, and engagement level, and suggest tailored messaging and actions.",
};
  const userId = sessionStorage.getItem("user_id");
  const apiKey = sessionStorage.getItem("api_key");

  const logAndHandleError = (message, error) => {
    console.error(message, error);
  };
  


const handleRemoveContact = (contactToRemove) => {
  const updatedContacts = contactInput
    .split(",")
    .map((c) => c.trim())
    .filter((c) => c !== contactToRemove)
    .join(", ");
  setContactInput(updatedContacts); // Update the contactInput state
};



  // const CustomerNavbar = ({ onButtonClick }) => {
  //   if (typeof onButtonClick !== "function") {
  //     console.error("onButtonClick prop must be a function.");
  //     return null;
  //   }
  //   return (
  //     <nav className="navbar">
  //       <button onClick={() => onButtonClick("Create Account Plan")}>Create Account Plan</button>
  //       <button onClick={() => onButtonClick("Create Opportunity")}>Create Opportunity</button>
  //       <button onClick={() => onButtonClick("Update or Review Existing Account Plan")}>
  //         Update or Review Existing Account Plan
  //       </button>
  //       <button onClick={() => onButtonClick("Update Customer details")}>Update Customer Details</button>
  //       <button onClick={() => onButtonClick("Log out")}>Log out</button>
  //     </nav>
  //   );
  // };
  const renderModalContent = () => {
    switch (activeModal) {
      case "saveOpportunity":
        return (
          <>
            <h3 style={{ color: 'white', marginBottom: '20px' }}>Create Opportunity</h3>
  
            {/* Customer Name */}
            <label style={{ color: 'white' }}>Customer Name</label>
            <input
              type="text"
              value={formData.customerName || ""}
              onChange={(e) => handleInputChange('customerName', e.target.value)}
              placeholder="Enter Customer Name"
              aria-label="Customer Name"
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
            />
  
            {/* Opportunity Name */}
            <label style={{ color: 'white' }}>Opportunity Name</label>
            <input
              type="text"
              value={formData.opportunityName || ""}
              onChange={(e) => handleInputChange('opportunityName', e.target.value)}
              placeholder="Enter Opportunity Name"
              aria-label="Opportunity Name"
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
            />
  
            {/* Lead Details */}
            <label style={{ color: 'white' }}>Lead Details</label>
            <textarea
              value={formData.leadDetails || ""}
              onChange={(e) => handleInputChange('leadDetails', e.target.value)}
              placeholder="Enter Lead Details"
              aria-label="Lead Details"
              rows="3"
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
            ></textarea>
  
            {/* Persona */}
            <label style={{ color: 'white' }}>Persona</label>
            <input
              type="text"
              value={formData.persona || ""}
              onChange={(e) => handleInputChange('persona', e.target.value)}
              placeholder="Enter Persona"
              aria-label="Persona"
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
            />
  
            {/* Lead Source */}
            <label style={{ color: 'white' }}>Lead Source</label>
            <select
              value={formData.leadSource || ""}
              onChange={(e) => handleInputChange('leadSource', e.target.value)}
              aria-label="Lead Source"
              style={{ width: '100%', marginBottom: '20px', padding: '8px' }}
            >
              <option value="" disabled>
                Select Lead Source
              </option>
              <option value="email">Email</option>
              <option value="phone">Phone</option>
              <option value="reference">Reference</option>
              <option value="direct contact">Direct Contact</option>
              <option value="conference">Conference</option>
            </select>
  
            {/* Buttons */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <button
                onClick={submitOpportunity}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#28a745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Save Opportunity
              </button>
              <button
                onClick={() => closeModal("saveOpportunity")}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#dc3545',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
            </div>
          </>
        );
  
      default:
        return null;
    }
  };
  
  
  const submitOpportunity = async () => {
    try {
      const payload = {
        user_id: userId,
        api_key: apiKey,
        customer_id: customer.customer_id, // Include customer_id
        customer_name: formData.customerName,
        opportunity_name: formData.opportunityName,
        lead_details: formData.leadDetails,
        persona: formData.persona,
        lead_source: formData.leadSource,
        commit_date: formData.commitDate, // Include commit_date
        value: formData.value, // Include value
      };
  
      console.log("Submitting Opportunity:", payload); // Debugging log
  
      // Send the POST request to the backend
      const response = await axios8001.post("/check_and_create_opportunity", payload);
  
      // Handle success (update the UI)
      setOpportunities((prevOpportunities) => [...prevOpportunities, response.data]);
      alert("Opportunity created successfully!");
      setModalVisible(false); // Close the modal
    } catch (error) {
      console.error("Error saving opportunity:", error);
      alert("Failed to save opportunity. Please try again.");
    }
  };
  
  
  const [formData, setFormData] = useState({
    customerName: "",
    opportunityName: "",
    leadDetails: "",
    persona: "",
    leadSource: "",
    commitDate: "", // Add commit_date
    value: "", // Add value
  });
  
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  
  const saveOpportunity = async () => {
    try {
      // Replace with your save logic
      console.log("Saving Opportunity:", formData);
      setFormData({
        customerName: "",
        opportunityName: "",
        leadDetails: "",
        persona: "",
      });
      alert("Opportunity saved successfully!");
      setModalVisible(false);
    } catch (error) {
      console.error("Error saving opportunity:", error);
    }
  };
  const onLogout = () => {
    // Clear user session data
    sessionStorage.removeItem("user_id");
    localStorage.removeItem("authToken"); // Optional: If using auth tokens
  
    // Redirect to login page
    window.location.href = "/";
  };
  

  const updateCustomerDetailsWorkflow = async () => {
    const addOrRemove = prompt('Would you like to add or remove contacts? (yes/no)');
    if (addOrRemove?.toLowerCase() === 'yes') {
      const addContact = prompt('Would you like to add a customer contact? (yes/no)');
      if (addContact?.toLowerCase() === 'yes') {
        const newContact = prompt('Enter the new contact name:');
        if (newContact) {
          await updateCustomerDetails({ addContact: newContact });
        }
      } else {
        const removeContact = prompt('Would you like to remove a customer contact? (yes/no)');
        if (removeContact?.toLowerCase() === 'yes') {
          const contactToRemove = prompt('Enter the contact name to remove:');
          if (contactToRemove) {
            await updateCustomerDetails({ removeContact: contactToRemove });
          }
        }
      }
    }

    const updateIndustry = prompt('Would you like to update the industry? (yes/no)');
    if (updateIndustry?.toLowerCase() === 'yes') {
      const newIndustry = prompt('Enter the new industry:');
      if (newIndustry) {
        await updateCustomerDetails({ industry: newIndustry });
      }
    }
  };

  // Fetch customer details on load
  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        if (!customer_name) {
          console.warn("Customer name is missing.");
          return;
        }

        const decodedCustomerName = decodeURIComponent(customer_name);
        const response = await axios8001.get("/get_customer_details", {
          params: { customer_name: decodedCustomerName },
        });

        const customerData = response.data;
        setCustomer({
          customer_id: customerData.customer_id,
          customer_name: customerData.customer_name,
          contact: customerData.contact || [],
          industry: customerData.industry || "",
        });
        setContactInput(customerData.contact?.join(", ") || "");
        setIndustryInput(customerData.industry || "");
      } catch (error) {
        console.error("Error fetching customer details:", error);
        setSnackbarMessage("Failed to load customer details. Please try again later.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

    fetchCustomerDetails();
  }, [customer_name]);


  // Handle form submission to update customer details
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedContact = contactInput.split(",").map((c) => c.trim());
      const updatedIndustry = industryInput;

      await axios8001.post("/update_customer_details", {
        user_id: userId,
        api_key: apiKey,
        customer_name: customer.customer_name,
        contact: updatedContact,
        industry: updatedIndustry,
      });

      setCustomer((prevCustomer) => ({
        ...prevCustomer,
        contact: updatedContact,
        industry: updatedIndustry,
      }));

      setSnackbarMessage("Customer details updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      logAndHandleError("Error updating customer details:", error);
      setSnackbarMessage("Failed to update customer details.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleButtonClick = (buttonName) => {
    switch (buttonName) {
      case "ask-coach":
      console.log("Ask Coach button clicked.");
      setIsCoachModalOpen(true);
      setActiveModal("askCoach"); // Set the active modal type
      break;
  
      case "Create Opportunity":
          setActiveModal("saveOpportunity");
          setModalVisible(true);
          break;
  
      case "Update or Review Existing Account Plan":
        if (accountId) {
          navigate(`/account/${accountId}`); // Navigate to the account plan page
        } else {
          console.warn("Account ID not found. Cannot navigate to account plan.");
        }
        break;
  
      case "Log out":
        sessionStorage.removeItem("user_id");
        setSnackbarMessage("Logged out successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/");
        }, 1000);
        break;
  
      default:
        console.warn("Unhandled button click:", buttonName);
    }
  };
  
  
  
  useEffect(() => {
    if (customer_name) {
      console.log("Customer Name from URL:", customer_name);
      setCustomer((prevCustomer) => ({
        ...prevCustomer,
        customer_name,
      }));
    } else {
      console.warn("Customer name not found in URL parameters.");
      navigate("/error"); // Navigate to an appropriate error page
    }
  }, [customer_name, navigate]);
  

  const updateCustomerDetails = async () => {
    try {
      const validContacts = contactInput
        .split(",")
        .map((c) => c.trim())
        .filter((c) => c) // Remove empty entries
        .join(", "); // Convert to a single comma-separated string
  
      const payload = {
        user_id: userId,
        api_key: apiKey,
        customer_name: customer.customer_name, // Required field
        contact: validContacts, // Send as a string
        industry: industryInput || customer.industry, // Optional
      };
  
      console.log("Payload sent to backend:", payload); // Debugging payload
  
      await axios8001.post("/update_customer_details", payload);
  
      setCustomer((prev) => ({
        ...prev,
        contact: validContacts.split(", "), // Store as an array in local state
        industry: industryInput || prev.industry,
      }));
  
      alert("Customer details updated successfully!");
    } catch (error) {
      console.error("Error updating customer details:", error);
      alert("Failed to update customer details.");
    }
  };
  
  
  
  const createAccountPlan = async () => {
    try {
      const response = await axios8001.post("/check_and_create_account", {
        user_id: userId,
        api_key: apiKey,
        customer_id: customer.customer_id,
      });
      setAccountId(response.data.account_id);
      navigate(`/account/${response.data.account_id}`);
    } catch (error) {
      console.error("Error creating account plan", error);
    }
  };

  const renderLearnings = () => {
    if (accountMetrics.learnings && accountMetrics.learnings.insights) {
      // Extract the insights string from the backend response
      const insightsText = accountMetrics.learnings.insights;
  
      // Split the insights into roles using "###" as the separator
      const roleInsights = insightsText
        .split("###") // Split by role headings
        .filter((section) => section.trim()) // Remove empty sections
        .map((section) => {
          // Extract role name and insights content
          const [role, ...content] = section.trim().split("\n");
          return {
            role: role.trim(), // e.g., "Sales Executives"
            content: content.join("\n").trim(), // Remaining content for the role
          };
        });
  
      // Render the insights
      return (
        <div className="learnings-container">
          {roleInsights.map(({ role, content }) => (
            <div key={role} className="learning-role">
              {/* Role Title */}
              <h4>{role}</h4>
              <ul className="learning-insights">
                {content
                  .split("\n") // Split into lines
                  .filter((line) => line.trim()) // Remove empty lines
                  .map((line, index) => {
                    // Check for subheading pattern (e.g., starts with "*Task Punctuality*", etc.)
                    if (line.trim().startsWith("1.") || line.trim().startsWith("2.") || line.trim().startsWith("3.")) {
                      // Subheading with description
                      const [subheading, ...description] = line.split(":");
                      return (
                        <li key={index}>
                          <strong>{subheading.trim()}:</strong> {description.join(":").trim()}
                        </li>
                      );
                    }
                    // Render general observations as plain text
                    return (
                      <li key={index}>
                        {line}
                      </li>
                    );
                  })}
              </ul>
            </div>
          ))}
        </div>
      );
    }
  
    // No learnings available fallback
    return <div>No learnings available</div>;
  };
  
  
  
  
  const renderDelayedTasks = () => {
    if (accountMetrics.tasks_delayed_per_role) {
      return (
        <ul>
          {Object.entries(accountMetrics.tasks_delayed_per_role).map(([role, count]) => (
            <li key={role}>
              <strong>{role}:</strong> {count} tasks delayed
            </li>
          ))}
        </ul>
      );
    }
    return <div>No delayed tasks reported</div>;
  };

  useEffect(() => {
    // Fetch data logic remains unchanged...
  }, [customer_name, userId, apiKey]);




const fetchCustomerAndOpportunities = useCallback(async () => {
  if (!customer_name || !userId || !apiKey) {
    console.warn("Missing required parameters: customer_name, userId, or apiKey.");
    setSnackbarMessage("Required parameters are missing.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return;
  }

  try {
    console.log("Fetching customer details for:", customer_name);

    // Step 1: Fetch customer details
    const customerResponse = await axios8001.get("/get_customer_details", {
      params: { customer_name },
    });

    const customerData = customerResponse.data;

    if (!customerData?.customer_id) {
      throw new Error("Customer ID not found for the given customer name.");
    }

    // Update customer state
    setCustomer({
      customer_id: customerData.customer_id,
      customer_name: customerData.customer_name,
      contact: Array.isArray(customerData.contact) ? customerData.contact : [],
      industry: customerData.industry || "",
    });

    console.log("Customer details fetched successfully:", customerData);

    // Step 2: Fetch opportunities for the customer
    console.log("Fetching opportunities for customer_id:", customerData.customer_id);
    const opportunitiesResponse = await axios8001.get("/get_opportunities_by_customer_id", {
      params: { customer_id: customerData.customer_id },
    });

    const opportunitiesList = opportunitiesResponse.data?.opportunities || [];

    // Enrich opportunities with additional metrics
    const enrichedOpportunities = await Promise.all(
      opportunitiesList.map(async (opportunity) => {
        try {
          const [stageMetricsResponse, closingProbabilityResponse] = await Promise.all([
            axios8200.get(`/sales_stage_health/${opportunity.opportunity_id}`),
            axios8200.get(`/closing_probability/${opportunity.opportunity_id}`),
          ]);

          return {
            ...opportunity,
            stage: stageMetricsResponse.data.sales_stage,
            health: stageMetricsResponse.data.Meddicc_health_score,
            compliance_score: stageMetricsResponse.data.compliance_score,
            closing_probability: closingProbabilityResponse.data.closing_probability,
          };
        } catch (error) {
          console.error(
            `Error fetching metrics for opportunity ${opportunity.opportunity_id}:`,
            error
          );
          return { ...opportunity, error: true }; // Add an error flag for failed metrics
        }
      })
    );

    setOpportunities(enrichedOpportunities);
    console.log("Opportunities enriched successfully:", enrichedOpportunities);

    // Step 3: Fetch account ID for the customer
    console.log("Fetching account ID for customer_id:", customerData.customer_id);
    const accountResponse = await axios8001.get("/get_account_id", {
      params: { customer_id: customerData.customer_id },
    });

    const account_id = accountResponse.data?.account_id;

    if (!account_id) {
      console.warn("No account ID found for the customer.");
      setSnackbarMessage("No account linked. Create an account plan.");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }

    setAccountId(account_id);
    setAccounts((prev) => ({
      ...prev,
      accountId: account_id,
    }));
    console.log("Fetched accountId and updated accounts:", account_id);

    // Step 4: Fetch account-related metrics
    console.log("Fetching account-related metrics for account_id:", account_id);
    const [tasksPerQuarterResponse, learningsResponse, delayedTasksResponse] = await Promise.all([
      axios8400.get(`/tasks_per_quarter/${account_id}`),
      axios8400.get(`/analyze_learnings/${account_id}`),
      axios8400.get(`/delayed_tasks_by_role/${account_id}`),
    ]);

    setAccountMetrics({
      tasks_per_quarter: tasksPerQuarterResponse.data || {},
      learnings: learningsResponse.data || "N/A",
      tasks_delayed_per_role: delayedTasksResponse.data || {},
    });

    console.log("Account-related metrics fetched successfully");
  } catch (error) {
    console.error("Error fetching customer or opportunities:", error.message || error);
    setSnackbarMessage("Failed to load customer or account details.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
}, [customer_name, userId, apiKey, setCustomer, setSnackbarMessage, setSnackbarSeverity, setSnackbarOpen, setOpportunities, setAccountId, setAccounts, setAccountMetrics]);


  const createOpportunity = async () => {
    const opportunity_name = prompt('Enter Opportunity Name');
    if (opportunity_name) {
      try {
        const data = {
          user_id: userId,
          api_key: apiKey,
          customer_name: customer.customer_name,
          opportunity_name
        };
        const response = await axios8001.post('/check_and_create_opportunity', data);
        setOpportunities([...opportunities, response.data]);
        navigate(`/opportunity/${response.data.opportunity_id}?customer_id=${customer.customer_id}&customer_name=${encodeURIComponent(customer.customer_name)}&opportunity_name=${encodeURIComponent(opportunity_name)}`);
      } catch (error) {
        console.error('Error creating opportunity:', error);
      }
    }
  };

  


  /* Ask Coach code */

  


  // Placeholder for opportunityId if dynamic
  const opportunityId = "example-id"; // Replace with actual logic or props


  // Function to handle chat input
  const handleSendMessage = async () => {
    if (!inputValue.trim()) return;

    setLoadingChat(true);

    try {
      const response = await axios8000.post("/chat", { message: inputValue });
      setChatMessages((prev) => [
        ...prev,
        { role: "user", content: inputValue },
        { role: "assistant", content: response.data.message },
      ]);
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setLoadingChat(false);
      setInputValue("");
    }
  };
  
  // Function to handle sending a message in the chat

  const handleCoachChat = async () => {
    if (!chatInput.trim()) {
      console.warn("Chat input is empty. Please enter a message.");
      return;
    }
  
    // Add a loading state message
    setConversationHistory((prev) => [
      ...prev,
      { role: "assistant", content: "Processing your request..." },
    ]);
    setLoadingChat(true);
  
    try {
      // Prepare API request
      const response = await axios8400.post("/askvaluecreationstrategycoach/", null, {
        params: {
          question: chatInput,
          user_id: userId || null,
          customer_name: customer?.customer_name || null,
          industry: customer?.industry || null,
        },
      });
  
      // Extract response data
      const { response: apiResponse, context } = response.data.data;
  
      // Determine the response content
      const coachResponse =
        typeof apiResponse === "string"
          ? apiResponse // Plain text response
          : apiResponse?.text || "No response from the coach."; // JSON response
  
      // Update conversation history with the response
      setConversationHistory((prev) => [
        ...prev,
        { role: "user", content: chatInput },
        { role: "assistant", content: coachResponse },
      ]);
  
      // Update account strategy if provided in the response
      if (context?.accounts && context.accounts !== "Not Available") {
        setAccounts({
          account_health_assessment: context.accountsy.account_health_assessment || "",
          macro_trends: context.accounts.macro_trends || "",
          business_issues_objectives: context.accounts.business_issues_objectives || "",
          relationship_mapping: context.accounts.relationship_mapping || "",
          whitespace_mapping: context.accounts.whitespace_mapping || "",
          value_creation: context.accounts.value_creation || "",
          actionable_quarter_plan: context.accounts.actionable_quarter_plan || "",
        });
      } else {
        console.warn("No valid account strategy found in the response context.");
      }
  
      // Clear input field
      setChatInput("");
    } catch (error) {
      // Handle errors and update chat
      let errorMessage = "An error occurred while processing your request.";
      if (error.response) {
        console.error("Error response:", error.response.status, error.response.data);
        errorMessage = `Error ${error.response.status}: ${
          error.response.data?.message || "Unexpected server error."
        }`;
      } else if (error.request) {
        console.error("No response received:", error.request);
        errorMessage = "No response from the server. Please check your network connection and try again.";
      } else {
        console.error("Error setting up request:", error.message);
      }
  
      setConversationHistory((prev) => [
        ...prev,
        { role: "error", content: errorMessage },
      ]);
    } finally {
      setLoadingChat(false); // End loading state
    }
  };
  
  const renderFormattedCoachResponse = (content) => {
    // Split the content into sections using "###"
    const sections = content.split("###").filter((section) => section.trim());
  
    return (
      <div style={{ marginTop: "10px" }}>
        {sections.map((section, index) => {
          const [heading, ...body] = section.split("\n").map((line) => line.trim());
          return (
            <div
              key={index}
              style={{
                background: "#ffffff",
                border: "1px solid #ccc",
                borderRadius: "10px",
                padding: "10px",
                marginBottom: "10px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
              }}
            >
              <h4 style={{ fontWeight: "bold", color: "#0056b3" }}>{heading}</h4>
              <div style={{ marginTop: "10px" }}>
                {body.map((paragraph, idx) => (
                  <p key={idx} style={{ margin: "5px 0", lineHeight: "1.6" }}>
                    {paragraph.replace(/^\d+\.\s*/, "")} {/* Remove bullet points */}
                  </p>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  
  
  // Function to handle sending messages
    const handleSendMessageWithContext = async (buttonKey) => {
      const context = contexts[buttonKey];
      const payload = {
        opportunity_id: opportunityId, // Ensure you define opportunityId in the parent component
        api_key: apiKey || null, // Pass null if api_key is not available
        user_id: userId || null, // Pass null if user_id is not available
        context, // Context provided for additional insights
        question: context, // Map context to the "question" field for the API requirement
      };
  
      if (!opportunityId) {
        console.error("Missing opportunity_id");
        setChatMessages((prevMessages) => [
          ...prevMessages,
          { role: "error", content: "Error: Missing opportunity ID." },
        ]);
        return;
      }
  
      console.log("Sending payload:", payload);
  
      // Add a loading state message
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: "Processing your request..." },
      ]);
      setLoadingChat(true);
  
      try {
        const response = await axios8000.post("/ask", payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        console.log("Message sent successfully:", response.data);
  
        setChatMessages((prevMessages) => [
          ...prevMessages,
          {
            role: "assistant",
            content: response.data?.data?.response || "No response received.",
          },
        ]);
      } catch (error) {
        let errorMessage = "An error occurred while processing your request.";
        if (error.response) {
          console.error("Error response:", error.response.status, error.response.data);
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.request) {
          console.error("No response received:", error.request);
          errorMessage = "No response received from the server.";
        } else {
          console.error("Error setting up request:", error.message);
        }
        setChatMessages((prevMessages) => [
          ...prevMessages,
          { role: "error", content: errorMessage },
        ]);
      } finally {
        setLoadingChat(false);
      }
    };

  
  const renderAskCoachTile = () => {
    // Define the contexts for each button
   const contexts = {
      "Lead Next Steps": "Provide personalized next steps for nurturing the lead and progressing the opportunity based on its current stage, MEDDICC alignment, and customer priorities.",
      "Fetch MEDDICC": "Retrieve and validate key MEDDICC components for this opportunity. Highlight missing elements, suggest actions, and provide questions to strengthen alignment.",
      "Competitor Insights": "Analyze potential competitors in this opportunity and suggest strategies to differentiate our solution, including objections to raise against competitors.",
      "Risk Mitigation": "Identify potential risks in this opportunity, such as low engagement or weak champions, and recommend actions to mitigate these risks.",
      "Analyze Tasks": "Assess pending tasks for the opportunity to ensure alignment with sales strategy. Highlight overdue or critical tasks and suggest adjustments for improved progress.",
      "Persona Analysis": "Analyze the personas involved in this opportunity. Highlight their priorities, influence, and engagement level, and suggest tailored messaging and actions.",
    };
  
    // Function to handle sending messages
    const handleSendMessageWithContext = async (buttonKey) => {
      const context = contexts[buttonKey];
      const payload = {
        opportunity_id: opportunityId, // Ensure you define opportunityId in the parent component
        api_key: apiKey || null, // Pass null if api_key is not available
        user_id: userId || null, // Pass null if user_id is not available
        context, // Context provided for additional insights
        question: context, // Map context to the "question" field for the API requirement
      };
  
      if (!opportunityId) {
        console.error("Missing opportunity_id");
        setChatMessages((prevMessages) => [
          ...prevMessages,
          { role: "error", content: "Error: Missing opportunity ID." },
        ]);
        return;
      }
  
      console.log("Sending payload:", payload);
  
      // Add a loading state message
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: "Processing your request..." },
      ]);
      setLoadingChat(true);
  
      try {
        const response = await axios8000.post("/ask", payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        console.log("Message sent successfully:", response.data);
  
        setChatMessages((prevMessages) => [
          ...prevMessages,
          {
            role: "assistant",
            content: response.data?.data?.response || "No response received.",
          },
        ]);
      } catch (error) {
        let errorMessage = "An error occurred while processing your request.";
        if (error.response) {
          console.error("Error response:", error.response.status, error.response.data);
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.request) {
          console.error("No response received:", error.request);
          errorMessage = "No response received from the server.";
        } else {
          console.error("Error setting up request:", error.message);
        }
        setChatMessages((prevMessages) => [
          ...prevMessages,
          { role: "error", content: errorMessage },
        ]);
      } finally {
        setLoadingChat(false);
      }
    };
  };





 // Function to generate account strategy
 const handleGenerateAccountStrategy = async () => {
  try {
    const response = await axios8400.post("/generate_account_strategy", {
      user_id: userId,
      customer_name: customer.customer_name, // Use customer_name instead of opportunity_id
    });
    setAccounts(response.data.accounts);
    setSnackbarMessage("Account strategy generated successfully!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error generating account strategy:", error);
    setSnackbarMessage("Failed to generate account strategy.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};

const handleSaveAccountStrategy = async () => {
  if (!customer?.customer_name) {
    console.warn("Customer name is missing. Cannot save account strategy.");
    setSnackbarMessage("Customer name is required to save account strategy.");
    setSnackbarSeverity("warning");
    setSnackbarOpen(true);
    return;
  }

  try {
    await axios8400.post(
      "/save_account_strategy/", 
      { accounts }, // Send accounts in the body
      {
        params: { customer_name: customer.customer_name }, // Send customer_name as query parameter
      }
    );
    setSnackbarMessage("Account strategy saved successfully!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error saving account strategy:", error);
    setSnackbarMessage("Failed to save account strategy.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  } finally {
    setIsSavingAndClosing(false);
  }
};
const fetchViewAndEditTasks = useCallback(async () => {
  console.log("Fetching View and Edit Account Tasks...");
  try {
    const response = await axios8400.post("/view_and_edit_account_tasks/", {
      account_id: accounts.accountId,
      api_key: apiKey,
      user_id: userId,
    });
    console.log("Fetched Tasks:", response.data.tasks);
    setTasks(response.data.tasks || []);
  } catch (error) {
    console.error("Error fetching View and Edit Tasks:", error);
  }
}, [accounts.accountId, apiKey, userId]);




const addExecutionUpdate = () => {
  const timestamp = new Date().toISOString();
  if (!newUpdate.trim()) {
    alert("Update text cannot be empty.");
    return;
  }
  setActiveTask((prev) => ({
    ...prev,
    execution_updates: [
      ...(prev.execution_updates || []),
      {
        update: newUpdate,
        user_id: userId,
        timestamp,
      },
    ],
  }));
  setNewUpdate(""); // Clear input after adding
};



const handleGenerateTasks = async () => {
  if (!accounts?.accountId) {
    setSnackbarMessage("No account ID available. Please try again.");
    setSnackbarSeverity("warning");
    setSnackbarOpen(true);
    return;
  }

  try {
    // Trigger task generation
    const response = await axios8400.post(
      "/generate_tasks/",
      {},
      { params: { account_id: accounts.accountId } }
    );

    if (response.status === 200) {
      setSnackbarMessage("Tasks generated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Fetch the latest tasks from the backend
      await fetchTasks(accounts.accountId);
    } else {
      console.error("Failed to generate tasks.");
      setSnackbarMessage("Failed to generate tasks.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  } catch (error) {
    console.error("Error generating tasks:", error);
    setSnackbarMessage("Error generating tasks.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  } finally {
    setIsGeneratingTasks(false);
  }
};

const saveTaskChanges = async (updatedTask) => {
  if (!updatedTask) {
    console.error("No task to save.");
    return;
  }

  try {
    const payload = {
      customer_name: customer.customer_name, // Ensure customer_name is passed
      tasks: [
        {
          task_id: updatedTask.task_id,
          task_name: updatedTask.task_name,
          description: updatedTask.description,
          status: updatedTask.status,
          start_date: updatedTask.start_date,
          end_date: updatedTask.end_date,
          execution_updates: updatedTask.execution_updates || [],
        },
      ],
    };

    console.log("Payload for saving task:", payload);

    const response = await axios8400.post(
      "/save_tasks/",
      payload,
      { params: { customer_name: customer.customer_name } }
    );

    if (response.status === 200) {
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.task_id === updatedTask.task_id ? updatedTask : task
        )
      );
      setSnackbarMessage("Task saved successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      closeModal(); // Close the modal after saving
    } else {
      console.error("Failed to save task. Status:", response.status);
      setSnackbarMessage("Failed to save task.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  } catch (error) {
    console.error("Error saving task changes:", error);
    setSnackbarMessage("Error saving task changes.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};




// Function to save tasks
const handleSaveTasks = async () => {
  if (!customer?.customer_name) {
    console.warn("Customer name is missing. Cannot save tasks.");
    setSnackbarMessage("Customer name is required to save tasks.");
    setSnackbarSeverity("warning");
    setSnackbarOpen(true);
    return;
  }

  if (!tasks || tasks.length === 0) {
    console.warn("No tasks to save.");
    setSnackbarMessage("No tasks available to save.");
    setSnackbarSeverity("warning");
    setSnackbarOpen(true);
    return;
  }

  try {
    const payload = {
      tasks: tasks.map((task) => ({
        task_id: task.task_id,
        task_name: task.task_name,
        description: task.description,
        status: task.status,
        start_date: task.start_date,
        end_date: task.end_date,
        execution_updates: task.execution_updates || [],
      })),
    };

    console.log("Payload being sent:", payload);

    const response = await axios8400.post("/save_tasks/", payload, {
      params: { customer_name: customer.customer_name }, // Add customer_name as query parameter
      headers: {
        "Content-Type": "application/json", // Ensure correct content type
      },
    });

    if (response.status === 200) {
      console.log("Tasks saved successfully:", response.data);
      setSnackbarMessage("Tasks saved successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } else {
      console.error("Failed to save tasks. Status:", response.status);
      setSnackbarMessage("Failed to save tasks.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  } catch (error) {
    console.error("Error saving tasks:", error);
    setSnackbarMessage("Failed to save tasks.");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  } finally {
    setIsSavingTasks(false);
  }
};

const fetchTasks = useCallback(async () => {
  if (!accounts?.accountId) {
    console.error("No account ID provided. Cannot fetch tasks.");
    return;
  }

  try {
    console.log(`Fetching tasks for account ID: ${accounts.accountId}`);
    const response = await axios8400.post("/view_and_edit_account_tasks/", {
      account_id: accounts.accountId,
      api_key: apiKey,
      user_id: userId,
    });

    if (response.status === 200) {
      console.log("Fetched tasks successfully:", response.data.tasks);
      setTasks(response.data.tasks || []);
    } else {
      console.error("Failed to fetch tasks. HTTP status:", response.status);
    }
  } catch (error) {
    console.error("Error fetching tasks:", error);
  } finally {
    setIsRefreshingTasks(false); // Reset loading state
  }
}, [accounts?.accountId, apiKey, userId]);

useEffect(() => {
  if (!customer.customer_name) {
    fetchCustomerAndOpportunities();
  }
}, [customer.customer_name, userId, apiKey]);

useEffect(() => {
  if (accounts?.accountId && apiKey && userId) {
    fetchViewAndEditTasks();
  }
}, [fetchViewAndEditTasks, accounts.accountId, apiKey, userId]);

useEffect(() => {
  if (accounts?.accountId) {
    fetchTasks();
  }
}, [fetchTasks]);

const handleTaskDoubleClick = (task) => {
  setActiveTask(task);
  setModalVisible(true);
  setActiveModal("editTask"); // Set active modal
  setIsCoachModalOpen(false); // Ensure Ask Coach is closed
};

const handleAskCoachClick = () => {
  setIsCoachModalOpen(true);
  setActiveModal("askCoach"); // Set active modal
  setModalVisible(false); // Ensure Edit Task is closed
};


  return (
    

    <div className="customer-container">
       <CustomerNavbar onButtonClick={handleButtonClick} /> 
      <div className="customer-details">
      <h2>{customer.customer_name}</h2>
      <button onClick={openEditModal} className="update-button">
        Update Customer Details
      </button>
    </div>
    
  
    {/* Modal for Editing */}
    {isModalOpen && (
      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <DialogTitle>Edit Customer Details</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="Contact"
            value={contactInput}
            onChange={(e) => setContactInput(e.target.value)}
            placeholder="Enter contact names separated by commas"
          />
          <TextField
            fullWidth
            margin="normal"
            label="Industry"
            value={industryInput}
            onChange={(e) => setIndustryInput(e.target.value)}
            placeholder="Enter industry"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              await updateCustomerDetails();
              setIsModalOpen(false);
            }}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )}
  
     {/* Flex Container for Opportunities and Account Plan */}
<div className="customer-sections">


  {/* Opportunities Section */}
  <div className="opportunities-section">
    <h3>Opportunities</h3>
    <ul>
      {opportunities.length > 0 ? (
        opportunities.map((opportunity) => (
          <li
            key={opportunity.opportunity_id}
            className="opportunity-container"
          >
            {/* Updated href to include customer_name and opportunity_name */}
            <a
              href={`/opportunity/${opportunity.opportunity_id}?customer_id=${customer.customer_id}&customer_name=${encodeURIComponent(customer.customer_name)}&opportunity_name=${encodeURIComponent(opportunity.opportunity_name)}`}>
              {opportunity.opportunity_name}
          
            </a>
            <div className="opportunity-metrics">
              <p>Stage: {opportunity.stage || "N/A"}</p>
              <p>Health: {opportunity.health || "N/A"}</p>
              <p>
                Compliance Score: {opportunity.compliance_score || "N/A"}
              </p>
              <p>Tasks: {opportunity.metrics?.total_tasks || 0}</p>
              <p>
                Delayed Tasks: {opportunity.metrics?.delayed_tasks || 0}
              </p>
              <p>
                Closing Probability:{" "}
                {opportunity.closing_probability || "N/A"}%
              </p>
            </div>
          </li>
        ))
      ) : (
        <p>No opportunities available.</p>
      )}
    </ul>
  </div>


       
       {/* Account Plan Section */}
<div className="account-plan-section">
  <h3>Account Plan</h3>
  {accountId ? (
    <>
      {/* Link to View Account Plan */}
      <a href={`/account/${accountId}`}>View Account Plan</a>

      {/* Account Metrics */}
      <div className="account-metrics">
        <div>Tasks per Quarter:</div>
        <ul>
          {Object.entries(accountMetrics.tasks_per_quarter).map(
            ([quarter, tasks], index) => (
              <li key={index}>
                {quarter}: {tasks}
              </li>
            )
          )}
        </ul>
        <div>Learnings:</div>
        {renderLearnings()}
        <div>Delayed Tasks by Role:</div>
        {renderDelayedTasks()}
      </div>

      {/* Account Strategy Link */}
      {accounts ? (
        <div className="account-strategy-link">
          <a
            href={`/accounts/${accounts.accountId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Account Strategy
          </a>
        </div>
      ) : (
        <p>No account strategy available. Use the coach to generate one.</p>
      )}
    </>
  ) : (
    <p>No account plan available. Please use the coach to get started.</p>
  )}
</div>



{/* Modal for AskValueCreationStrategyCoach */}
{isCoachModalOpen && (
  <Dialog
    fullWidth
    maxWidth="lg"
    open={isCoachModalOpen}
    onClose={() => setIsCoachModalOpen(false)} // Close modal
  >
    <DialogTitle>
      Ask Value Creation Strategy Coach
      <button
        style={{
          position: "absolute",
          top: "8px",
          right: "16px",
          background: "none",
          border: "none",
          fontSize: "16px",
          cursor: "pointer",
        }}
        onClick={() => setIsCoachModalOpen(false)}
      >
        ✕
      </button>
    </DialogTitle>
    <DialogContent>
      <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
        {/* Left Section: Chat */}
        {/* Chat Section */}
<div style={{ flex: 1, borderRight: "1px solid #ddd", paddingRight: "20px" }}>
  <h3>Chat</h3>
  {/* Chat History */}
  <div
    style={{
      height: "300px",
      overflowY: "auto",
      border: "1px solid #ddd",
      padding: "10px",
      borderRadius: "10px",
    }}
  >
    {conversationHistory.map((msg, index) => (
      <div
        key={index}
        style={{
          background: msg.role === "user" ? "#f0f8ff" : "#e0e0e0",
          padding: "10px",
          borderRadius: "10px",
          marginBottom: "10px",
          lineHeight: "1.5",
          whiteSpace: "pre-wrap",
        }}
      >
        <strong>{msg.role === "user" ? "You:" : "Coach:"}</strong>
        {msg.role === "assistant" ? (
          renderFormattedCoachResponse(msg.content)
        ) : (
          <p>{msg.content}</p>
        )}
      </div>
    ))}
  </div>
  {/* Chat Input */}
  <TextField
    fullWidth
    margin="normal"
    label="Ask a question"
    value={chatInput}
    onChange={(e) => setChatInput(e.target.value)}
    placeholder="Type your message here..."
  />
  <Button
    onClick={handleCoachChat}
    variant="contained"
    color="primary"
    style={{ marginTop: "10px" }}
  >
    Send
  </Button>
</div>


        {/* Middle Section: Account Plan */}
        <div style={{ flex: 2, paddingRight: "20px" }}>
          <h3>Account Plan</h3>
          {accounts ? (
            <div>
              {/* Render account plan details */}
              {[
                { label: "Account Health Assessment", key: "account_health_assessment" },
                { label: "MacroEconomic and Industry Trends", key: "macro_trend" },
                { label: "Business Issues & Objectives", key: "business_issues_objectives" },
                { label: "Relationship Mapping", key: "relationship_mapping" },
                { label: "Whitespace Mapping", key: "whitespace_mapping" },
                { label: "Value Creation Mapping", key: "value_creation" },
                { label: "Actionable QTR by QTR Plan", key: "actionable_quarter_plan" },
              ].map((field) => (
                <TextField
                  key={field.key}
                  fullWidth
                  margin="normal"
                  label={field.label}
                  multiline
                  rows={3}
                  value={accounts[field.key] || ""}
                  onChange={(e) =>
                    setAccounts((prev) => ({
                      ...prev,
                      [field.key]: e.target.value,
                    }))
                  }
                />
              ))}
              <Button
                variant="contained"
                color="secondary"
                onClick={handleGenerateTasks}
                style={{ marginTop: "10px" }}
                >
                {isGeneratingTasks ? "Generating..." : "Generate Tasks"}
               
              </Button>
            </div>
          ) : (
            <p>No account strategy available. Use the chat to generate one.</p>
          )}
        </div>

        {/* Right Section: Tasks */}
       {/* Right Section: Tasks */}
       <div style={{ flex: 1 }}>
  <h3>Tasks</h3>
  {tasks.length > 0 ? (
    <ul style={{ listStyleType: "none", padding: 0 }}>
      {tasks.map((task, index) => {
        // Assign a random background color if not already set
        const randomColor = task.randomColor || `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        task.randomColor = randomColor; // Save the random color in the task object

        return (
          <li
            key={task.task_id || index}
            className="task-card"
            style={{
              backgroundColor: randomColor,
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "4px",
              color: "#fff",
              cursor: "pointer",
              textAlign: "center",
            }}
            onDoubleClick={() => handleTaskDoubleClick(task)} // Open task modal on double-click
          >
            {task.task_name || `Task ${index + 1}`}
          </li>
        );
      })}
    </ul>
  ) : (
    <p>No tasks available. Generate tasks using the account strategy.</p>
  )}
  <Button
    variant="contained"
    color="primary"
    style={{ marginTop: "10px" }}
    onClick={() => fetchTasks(accounts.accountId)} // Option to manually refresh tasks
    >
    {isRefreshingTasks ? "Refreshing..." : "Refresh Tasks"}
   
  </Button>





          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "10px" }}
            onClick={handleSaveTasks}
            >
            {isSavingTasks ? "Saving..." : "Save Tasks"}
          
          </Button>
        </div>
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          handleSaveAccountStrategy();
          handleSaveTasks();
          setIsCoachModalOpen(false);
        }}
        >
        {isSavingAndClosing ? "Saving & Closing..." : "Save & Close"}
       
      </Button>
      <Button
        variant="outlined"
        onClick={() => setIsCoachModalOpen(false)}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
)}


{modalVisible && (
  <div className="task-modal">
    <div className="task-modal-content">
      {/* Check the active modal type */}
      {activeModal === "editTask" && (
        <>
          <h3>Edit Task</h3>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!activeTask.task_name.trim()) {
                alert("Task name cannot be empty.");
                return;
              }
              saveTaskChanges(activeTask); // Explicitly pass the active task for saving
            }}
          >
            {/* Task Name */}
            <label htmlFor="task-name">Name:</label>
            <input
              id="task-name"
              type="text"
              value={activeTask?.task_name || ""}
              onChange={(e) =>
                setActiveTask((prev) => ({
                  ...prev,
                  task_name: e.target.value,
                }))
              }
              placeholder="Enter task name"
              required
              autoFocus
            />

            {/* Description */}
            <label htmlFor="task-description">Description:</label>
            <textarea
              id="task-description"
              value={activeTask?.description || ""}
              onChange={(e) =>
                setActiveTask((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              placeholder="Enter task description"
              rows="3"
            ></textarea>

            {/* Status */}
            <label htmlFor="task-status">Status:</label>
            <select
              id="task-status"
              value={activeTask?.status || "Not Started"}
              onChange={(e) =>
                setActiveTask((prev) => ({
                  ...prev,
                  status: e.target.value,
                }))
              }
            >
              <option value="Not Started">Not Started</option>
              <option value="Started">Started</option>
              <option value="Completed">Completed</option>
              <option value="Blocked">Blocked</option>
            </select>

            {/* Start Date */}
            <label htmlFor="task-start-date">Start Date:</label>
            <input
              id="task-start-date"
              type="date"
              value={activeTask?.start_date || ""}
              onChange={(e) =>
                setActiveTask((prev) => ({
                  ...prev,
                  start_date: e.target.value,
                }))
              }
            />

            {/* End Date */}
            <label htmlFor="task-end-date">End Date:</label>
            <input
              id="task-end-date"
              type="date"
              value={activeTask?.end_date || ""}
              onChange={(e) =>
                setActiveTask((prev) => ({
                  ...prev,
                  end_date: e.target.value,
                }))
              }
            />

            {/* Execution Updates */}
            <h4>Execution Updates</h4>
            <ul>
              {activeTask.execution_updates?.length > 0 ? (
                activeTask.execution_updates.map((update, idx) => (
                  <li key={idx}>
                    <strong>
                      {new Date(update.timestamp).toLocaleString()}
                    </strong>
                    : {update.update}
                  </li>
                ))
              ) : (
                <p>No updates yet.</p>
              )}
            </ul>

            {/* Add Update */}
            <label htmlFor="new-update">Add Update:</label>
            <textarea
              id="new-update"
              value={newUpdate || ""}
              onChange={(e) => setNewUpdate(e.target.value)}
              placeholder="Enter your update here"
              rows="2"
            ></textarea>
            <button
              type="button"
              onClick={() => {
                if (!newUpdate.trim()) {
                  alert("Update text cannot be empty.");
                  return;
                }
                addExecutionUpdate();
              }}
              style={{
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#007bff",
                color: "#00000",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Add Update
            </button>

            {/* Modal Buttons */}
            <div className="modal-buttons">
              <button
                type="submit"
                style={{
                  marginRight: "10px",
                  padding: "10px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                >
                {isSavingTasks ? "Saving..." : "Save"}
              
              </button>
              <button
                type="button"
                onClick={() => {
                  closeModal();
                  setNewUpdate(""); // Clear update field
                }}
                style={{
                  padding: "10px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </>
      )}

     {/* Save Opportunity Modal */}
{activeModal === "saveOpportunity" && (
  <>
    <h3 style={{ color: "white" }}>Create Opportunity</h3>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submitOpportunity(); // Call saveOpportunity logic
      }}
    >
      {/* Customer Name */}
      <label style={{ color: "white" }}>Customer Name</label>
      <input
        type="text"
        value={formData.customerName || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            customerName: e.target.value,
          }))
        }
        placeholder="Enter Customer Name"
        required
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {/* Opportunity Name */}
      <label style={{ color: "white" }}>Opportunity Name</label>
      <input
        type="text"
        value={formData.opportunityName || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            opportunityName: e.target.value,
          }))
        }
        placeholder="Enter Opportunity Name"
        required
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {/* Lead Details */}
      <label style={{ color: "white" }}>Lead Details</label>
      <textarea
        value={formData.leadDetails || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            leadDetails: e.target.value,
          }))
        }
        placeholder="Enter Lead Details"
        rows="3"
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      ></textarea>

      {/* Persona */}
      <label style={{ color: "white" }}>Persona</label>
      <input
        type="text"
        value={formData.persona || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            persona: e.target.value,
          }))
        }
        placeholder="Enter Persona"
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {/* Lead Source */}
      <label style={{ color: "white" }}>Lead Source</label>
      <select
        value={formData.leadSource || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            leadSource: e.target.value,
          }))
        }
        style={{ width: "100%", marginBottom: "20px", padding: "8px" }}
      >
        <option value="" disabled>
          Select Lead Source
        </option>
        <option value="email">Email</option>
        <option value="phone">Phone</option>
        <option value="reference">Reference</option>
        <option value="direct contact">Direct Contact</option>
        <option value="conference">Conference</option>
      </select>

      {/* Commit Date */}
      <label style={{ color: "white" }}>Commit Date</label>
      <input
        type="date"
        value={formData.commitDate || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            commitDate: e.target.value,
          }))
        }
        placeholder="Enter Commit Date"
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {/* Value */}
      <label style={{ color: "white" }}>Value (in dollars)</label>
      <input
        type="number"
        value={formData.value || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            value: e.target.value,
          }))
        }
        placeholder="Enter Value"
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {/* Buttons */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Save Opportunity
        </button>
        <button
          type="button"
          onClick={() => closeModal("saveOpportunity")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </form>
  </>
)}

    </div>
  </div>
)}





    </div>
    </div>
  );  
};

export default CustomerPage;
